export const MAX_VACANCIES_MAIN_PAGE = 4;
export const TICKER_REPEAT_COUNT = 5
